import i18n from 'modules/core/lib/i18n'

export const getReviewLabel = (reviewState: string) => {
  switch (reviewState) {
    case 'draft':
      return i18n.t('surveys.review.write_reviews.draft')
    case 'active':
      return i18n.t('surveys.review.write_reviews.active')
    case 'completed':
      return i18n.t('surveys.review.write_reviews.completed')
    case 'closed':
      return i18n.t('surveys.review.write_reviews.closed')
    default:
      return i18n.t('surveys.review.write_reviews.unknown')
  }
}
